import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './layouts/admin/admin.component';
import { HttpClientModule } from '@angular/common/http';

import { ApiService } from './services/shared/api.service';
import { AuthenticationService } from './services/shared/auth.service';

import { ErrorMessageHandler } from './helpers/error-handler';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DpIntergrationComponent } from './layouts/admin/components/dp-intergration/dp-intergration.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DashboardComponent } from './layouts/admin/components/dashboard/dashboard.component';
import { SidenavV2Component } from './layouts/admin/components/sidenav/sidenav-v2/sidenav-v2.component'
import { SalesReportComponent } from './layouts/admin/components/sales-report/sales-report.component'

import { ChartsModule } from 'ng2-charts';
import { MomentModule } from 'ngx-moment';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { UiSwitchModule } from 'ngx-ui-switch';
import { TileComponent } from './layouts/admin/components/tile/tile.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EventEmitterService } from './services/shared/event-emitter.service';
import { ProgressBarModule } from "angular-progress-bar";
import { CanAccessDirective } from './directives/can-access.directive';

import { ShowHideDirective } from './directives/show-hide.directive';
import { OrderComponent } from './layouts/admin/components/order/order.component';
import { SharedModule } from './layouts/shared/shared.module';
import { AccountInfoComponent } from './layouts/admin/components/settings/settings-v2/account-info/account-info.component';
import { IntegrationInfoComponent } from './layouts/admin/components/settings/settings-v2/integration-info/integration-info.component';
import { OrderActionsComponent } from './layouts/admin/components/settings/settings-v2/order-actions/order-actions.component';
import { PosIntegrationInfoComponent } from './layouts/admin/components/settings/settings-v2/pos-integration-info/pos-integration-info.component';
import { SettingsV2Component } from './layouts/admin/components/settings/settings-v2/settings-v2.component';
import { NormalUserDirective } from './directives/normal-user.directive';

//Firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { common_environment } from '../environments/common.environment';
import { UserService } from './services/user/user.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DirectivesModule } from './directives/directives.module';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    DpIntergrationComponent,
    DashboardComponent,
    OrderComponent,
    TileComponent,
    CanAccessDirective,
    SettingsV2Component,
    IntegrationInfoComponent,
    PosIntegrationInfoComponent,
    OrderActionsComponent,
    AccountInfoComponent,
    SidenavV2Component,
    SalesReportComponent,
    NormalUserDirective

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressBarModule,
    BrowserAnimationsModule,
    ChartsModule,
    MomentModule.forRoot({
      relativeTimeThresholdOptions: {
        'm': 59
      }
    }),
    BsDatepickerModule.forRoot(),
    UiSwitchModule.forRoot({
      size: 'small',
      color: 'rgb(0, 189, 99)',
      switchColor: '#80FFA2',
      defaultBgColor: '#00ACFF',
      defaultBoColor: '#476EFF',
      checkedLabel: 'on',
      uncheckedLabel: 'off'
    }),
    NgxSkeletonLoaderModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule.forRoot(),
    AngularFireModule.initializeApp(common_environment.firebase),
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    SharedModule,
    PdfViewerModule,
    DirectivesModule
  ],
  providers: [ApiService, UserService, ErrorMessageHandler, AuthenticationService, EventEmitterService,],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
